<div class="content unselectable">
    @if(!chatStore.messages() || chatStore.messages().length === 0) {
    <div class="greetigs">
        <div class="greetings-content">
            <div class="title">
                <div>
                    Hello, Jordan.
                </div>
                <div>
                    How can I help you?
                </div>
            </div>
            <div class="actions">
                @for (item of homeContentStore.prompts(); track item.id) {
                <div class="button" (click)="applyPrompt(item)">
                    {{item.title}}
                </div>
                }
            </div>
        </div>
    </div>
    }

    @if(chatStore.messages() && chatStore.messages().length > 0) {
    <div class="scroll-container" #scrollframe>
        <div class="chat">
            @for (message of chatStore.messages(); track message.id; let i = $index;) {
            <div class="message" [ngClass]="{
                'send': !message.isResponse,
                'received': message.isResponse,
                'hidden': i === chatStore.messages().length - 1 && isRecording()}">
                @if (message.isResponse) {
                <img src="assets/images/voice/zIcon_Red-RGB 1 small.svg" alt="agent logo" class="agent-logo">
                }
                @let text = message.text();
                @if(text !== null) {
                <div>
                    @if (message.isResponse) {
                        @if (message.incomplete()) {
                            <p style="font-size: 0.8em; color: #666666; line-height: 1.3em; padding-bottom: 1em;">Message beginning lost due to a network issue. Will be restored when generation completes.</p>
                        }
                    <markdown [data]="text"></markdown>
                    } @else {
                    {{ text }}
                    }
                    <!-- @if((i === chatStore.messages().length - 1) && message.isResponse && !isResponseReceived()) {
                    <span class="typing-indicator">
                        <span></span>
                        <span></span>
                        <span></span>
                    </span>
                    } -->
                    @if (message.isResponse) {
                    <div class="message-actions">
                        <app-message-control [message]="message"></app-message-control>
                    </div>
                    }
                </div>
                }

                @let images = getDisplayableAttachments(message);
                @if (images) {
                    <div class="message-files">
                        @for (file of images; track file.attachmentId) {
                            @if (file.displayUrl) {
                                <section class="file-preview">
                                        <img *ngIf="(file.displayUrl | authImage | async) as resolvedUrl; else loading" [src]="resolvedUrl" [alt]="file.attachmentId" />
                                </section>
                            }
                        }
                    </div>

                <!-- Fallback template while fetching the image -->
                    <ng-template #loading>
                      <div class="placeholder-spinner">Loading...</div>
                    </ng-template>
                }

                @if(!message.isResponse && (text === null || text === '') && images.length === 0) {
                <!-- We have nothing to display, that probably means we are waiting for some content so display loader -->
                <span class="typing-indicator">
                    <span></span>
                    <span></span>
                    <span></span>
                </span>
                <!--                        @let audio = getPlayableAttachments(message);-->
                <!--                        @if (audio.length > 0 || (text === '' && images.length === 0)) {-->
                <!--                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">-->
                <!--                            <path stroke-linecap="round" stroke-linejoin="round" d="M19.114 5.636a9 9 0 0 1 0 12.728M16.463 8.288a5.25 5.25 0 0 1 0 7.424M6.75 8.25l4.72-4.72a.75.75 0 0 1 1.28.53v15.88a.75.75 0 0 1-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.009 9.009 0 0 1 2.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z" />-->
                <!--                        </svg>-->
                <!--                        }-->
                }
            </div>
            }
        </div>
    </div>
    }
    <div class="actions">
        @if(!isResponseReceived()) {
        <div class="fetching-indicator">
            <span class="server-status-message">
                @let message = serverStatusMessage() ? serverStatusMessage() : 'Analyzing';
                @for (letter of message | splitByLetter; track $index) {
                <span class="blink-letter"
                      [style.animationDelay]="$index * 30 + 'ms'">{{letter}}</span>
                }
            </span>
            <!-- <span class="typing-indicator">
                <span></span>
                <span></span>
                <span></span>
            </span> -->
        </div>
        }
        <div class="user-message">
            <div class="files-preview-panel" [class]="{ 'has-files': selectedFiles().length > 0} ">
                @for (filePreview of selectedFiles(); track $index;; let i = $index;) {
                @if(filePreview && filePreview.file) {
                <span class="file-preview-container">
                    @if(filePreview.file.type.startsWith('image')) {
                    <img [src]="filePreview.url" class="file-preview image" />
                    } @else {
                    <img src="assets/images/voice/file.svg" class="file-preview" />
                    }
                    <img src="assets/images/voice/noun-close-8408218 1.svg" class="close" title="Remove"
                         (click)="removeSelectedFile(i);" />
                </span>
                }
                }
            </div>
            <input [(ngModel)]="messageText" placeholder="Start typing..." (keydown.enter)="send()" id="input-user-prompt"
                   class="input-user-prompt"
                   [class]="{ 'has-files': selectedFiles().length > 0, 'disabled': !isResponseReceived()} " />
            <img src="assets/images/chat/noun-send-5070476 1.svg" alt="send" class="action-image send"
                 [class]="{'disabled': !isResponseReceived()}"
                 (click)="send()">
        </div>
        <div class="buttons">
            <input id="camera-input"
                   type="file"
                   accept="image/*"
                   capture="environment"
                   multiple="true"
                   style="display: none;"
                   (change)="onCameraPhoto($event)">
            <label for="camera-input" class="action-image">
                <!-- <img src="assets/images/voice/Camera Button.svg" alt="camera" class="action-image"> -->
            </label>
            <input id="gallery-input"
                   type="file"
                   accept="image/*;capture=camera"
                   multiple="true"
                   style="display: none;"
                   (change)="onCameraPhoto($event)" />

            <label for="gallery-input">
                <img src="assets/images/voice/Add Button.svg" id="upload-menu" alt="menu" class="action-image" />
            </label>

            <!--            <div class="dropdown">-->
            <!--                <img src="assets/images/voice/Add Button.svg" id="upload-menu" alt="menu" class="action-image"-->
            <!--                        (click)="isUploadMenuOpen = !isUploadMenuOpen">-->
            <!--                @if(isUploadMenuOpen) {-->
            <!--                <ul class="dropdown-panel" id="upload-dropdown-panel">-->
            <!--                    <li>-->
            <!--                      <label for="camera-input">-->
            <!--                        <span class="item nobr">-->
            <!--                            <img src="assets/images/voice/camera-outline.svg" />-->
            <!--                            Camera-->
            <!--                        </span>-->
            <!--                      </label>-->
            <!--                    </li>-->
            <!--                    <li class="space"></li>-->
            <!--                    <li>-->
            <!--                      <label for="gallery-input">-->
            <!--                        <span class="item nobr">-->
            <!--                            <img src="assets/images/voice/gallery-filled.svg" />-->
            <!--                            Photos-->
            <!--                        </span>-->
            <!--                      </label>-->
            <!--                    </li>-->
            <!--                    &lt;!&ndash; <li class="space"></li>-->
            <!--                    <li (click)="isUploadMenuOpen = !isUploadMenuOpen">-->
            <!--                        <span class="nobr">-->
            <!--                            Upload a-->
            <!--                        </span>-->
            <!--                        <br />-->
            <!--                        <span class="nobr">-->
            <!--                            document-->
            <!--                        </span>-->
            <!--                    </li> &ndash;&gt;-->
            <!--                </ul>-->
            <!--                }-->
            <!--            </div>-->

            <img src="assets/images/voice/zIcon_Red-RGB 1.svg" alt="play" class="action-image play"
                 [class]="{'recording': isRecording(), 'disabled': !isResponseReceived()}" (click)="record()">

            <img src="assets/images/voice/Close.svg" alt="Close" class="action-image"
                 (click)="close()">
        </div>
    </div>
</div>

